module.exports = __webpack_public_path__ + "static/9-fb3db9e54f9ea66d3791d6e84f309342.jpg";